import useOrganizationName from '@/hooks/useOrganizationName';
import api from '@/services/api';
import {
  keepPreviousData,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import type {
  ColumnFiltersState,
  PaginationState,
  SortingState
} from '@tanstack/react-table';
import { useEffect } from 'react';

export type GetServicesProps = {
  pagination: PaginationState;
  filtering: string;
  sorting: SortingState;
  columnFilters: ColumnFiltersState;
  organizationName?: string;
};

const getQueryOptions = ({
  pagination,
  filtering,
  sorting,
  columnFilters,
  organizationName
}: GetServicesProps) => {
  return {
    queryKey: [
      'services',
      pagination,
      { search: filtering },
      sorting,
      columnFilters,
      organizationName
    ],
    queryFn: () =>
      api.services.getPaginatedServices({
        pagination,
        filtering,
        sorting,
        columnFilters
      })
  };
};

const useGetPaginatedServices = (props: GetServicesProps) => {
  const organizationName = useOrganizationName();

  const queryClient = useQueryClient();

  //prefetch next page
  useEffect(() => {
    queryClient.prefetchQuery(
      getQueryOptions({
        ...props,
        organizationName,
        pagination: {
          ...props.pagination,
          pageIndex: props.pagination.pageIndex + 1
        }
      })
    );
  }, [queryClient, props, organizationName]);

  return useQuery({
    ...getQueryOptions({ ...props, organizationName }),
    placeholderData: keepPreviousData
  });
};

export default useGetPaginatedServices;
